import React, { useState } from 'react'
import { Animated, StyleSheet } from 'react-native'

import { colors, Icon, Pressable, XStack } from '@zet/design-system'
import { navigateTo, navigationRef } from '@zet/utils/navigation'
import { HeaderProps, MenuTooltip } from '@zet/zet-prime'
import DOT_MENU from '@zet/zet-prime/assets/svgs/dotMenu.svg'

export default function Header({
  backButtonAnimatedValue = new Animated.Value(1),
  setIsCancelSubscriptionSheetVisible,
  showOptions = true,
}: HeaderProps) {
  const [showTooltip, setShowTooltip] = useState(false)

  const handleMenuPress = () => {
    setShowTooltip(!showTooltip)
  }

  const handleSupport = () => {
    navigateTo('HelpAndSupport')
    setShowTooltip(false)
  }

  return (
    <XStack className="absolute top-3 left-0 right-0 z-10 justify-between px-3">
      <Animated.View
        style={[
          styles.backButtonContainer,
          {
            opacity: backButtonAnimatedValue.interpolate({
              inputRange: [0, 100],
              outputRange: [0.7, 1],
              extrapolate: 'clamp',
            }),
          },
        ]}
      >
        <Pressable
          className="items-center justify-center"
          onPress={() =>
            navigationRef.canGoBack()
              ? navigationRef?.goBack()
              : navigateTo('HomeView')
          }
        >
          <Icon type="ArrowLeft" color={colors.grays[80]} />
        </Pressable>
      </Animated.View>
      {showOptions && (
        <Animated.View
          style={[
            styles.backButtonContainer,
            {
              opacity: backButtonAnimatedValue.interpolate({
                inputRange: [0, 100],
                outputRange: [0.7, 1],
                extrapolate: 'clamp',
              }),
            },
          ]}
        >
          <Pressable
            className="items-center justify-center"
            onPress={handleMenuPress}
          >
            <DOT_MENU />
          </Pressable>
        </Animated.View>
      )}

      {showTooltip && setIsCancelSubscriptionSheetVisible && (
        <MenuTooltip
          setIsCancelSubscriptionSheetVisible={
            setIsCancelSubscriptionSheetVisible
          }
          setShowTooltip={setShowTooltip}
          onSupport={handleSupport}
        />
      )}
    </XStack>
  )
}

const styles = StyleSheet.create({
  backButtonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,

    elevation: 7,
  },
})
